import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TableInfo } from '../../services/tables/interfaces/table.interface';

type TableType = 'LOCAL' | 'DELIVERY' | 'PICKUP' | 'FOODTRUCK';

@Component({
  selector: 'app-table-edit-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCheckboxModule
  ],
  template: `
    <div class="dialog-wrap">
      <div class="dialog-title">Editar mesa</div>
      <div class="dialog-content">
        <mat-form-field appearance="fill" class="w-full mb-3">
          <mat-label>Nombre</mat-label>
          <input matInput [(ngModel)]="name" placeholder="Ej: Mesa 1" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full mb-3">
          <mat-label>Tipo</mat-label>
          <mat-select [(ngModel)]="type">
            <mat-option *ngFor="let t of types" [value]="t">{{ labelForType(t) }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-checkbox [(ngModel)]="enabled">Habilitada</mat-checkbox>
      </div>
      <div class="dialog-actions">
        <button mat-stroked-button (click)="onCancel()">Cancelar</button>
        <button mat-flat-button color="primary" (click)="onSave()">Guardar</button>
      </div>
    </div>
  `,
  styles: [
    `
    .dialog-wrap{padding:8px 4px; min-width: 320px}
    .dialog-title{font-size:16px;font-weight:600;margin-bottom:8px}
    .dialog-content{margin-bottom:12px}
    .w-full{width:100%}
    .mb-3{margin-bottom:12px}
    .dialog-actions{display:flex; gap:8px; justify-content:flex-end}
    /* Ocultar líneas verticales/notch del form-field (material MDC) */
    :host ::ng-deep .mat-mdc-form-field .mdc-notched-outline,
    :host ::ng-deep .mat-mdc-form-field .mdc-notched-outline__leading,
    :host ::ng-deep .mat-mdc-form-field .mdc-notched-outline__notch,
    :host ::ng-deep .mat-mdc-form-field .mdc-notched-outline__trailing,
    :host ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-outline,
    :host ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-outline-gap,
    :host ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-outline-start,
    :host ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-outline-end,
    :host ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-focus-overlay { display: none !important; border: 0 !important; }
    :host ::ng-deep .mat-mdc-form-field-subscript-wrapper { height: 0 !important; display: none !important; padding: 0 !important; margin: 0 !important; }
    `
  ]
})
export class TableEditDialogComponent {
  name = '';
  enabled = true;
  type: TableType = 'LOCAL';
  types: TableType[] = ['LOCAL', 'DELIVERY', 'PICKUP', 'FOODTRUCK'];

  constructor(
    private dialogRef: MatDialogRef<TableEditDialogComponent, Partial<TableInfo> | null>,
    @Inject(MAT_DIALOG_DATA) public data: { table: TableInfo; types?: TableType[] }
  ) {
    const t = data?.table;
    this.name = (t?.name || '').toString();
    this.enabled = t?.enabled !== false; // default true
    this.type = (t?.type as TableType) || 'LOCAL';
    if (data?.types && Array.isArray(data.types) && data.types.length > 0) {
      this.types = data.types as TableType[];
    }
  }

  labelForType(t: TableType): string {
    switch (t) {
      case 'DELIVERY': return 'Delivery';
      case 'PICKUP': return 'Pickup';
      case 'FOODTRUCK': return 'Foodtruck';
      default: return 'Local';
    }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onSave(): void {
    const cleanName = (this.name || '').trim();
    const payload: Partial<TableInfo> = {
      name: cleanName,
      enabled: !!this.enabled,
      type: this.type
    };
    this.dialogRef.close(payload);
  }
}